import ShellEditor from './ShellEditor';

export default ShellEditor;
